// utils/schemaGenerators.js

export function generateArticleSchema(metadata, slug) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": metadata.title,
    "description": metadata.excerpt,
    "author": {
      "@type": "Organization",
      "name": "Modern Build Home Remodeling"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Modern Build Home Remodeling",
      "logo": {
        "@type": "ImageObject",
        "url": "https://modernbuildremodel.com/modern-build-home-remodeling-logo.webp"
      }
    },
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `https://modernbuildremodel.com/blog/${slug}`
    },
    "datePublished": new Date(metadata.date).toISOString(), // ISO format
    "image": `https://modernbuildremodel.com${metadata.image}`
  };
}
